import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    AbstractSelectSearchControlComponent
} from "../../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {ExtraSearchModel} from "../extra-search.model";
import {ExtraSearchPageComponent} from "../extra-search-page/extra-search-page.component";
import {
    registerSearchControl
} from "../../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-extra-multi-select-search-control",
    templateUrl: "../../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        provideSearchModel(ExtraSearchModel),
        registerSearchControl(ExtraMultiSelectSearchControlComponent)
    ]
})
export class ExtraMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<ExtraSearchModel> {
    constructor(model: ExtraSearchModel, injector: Injector) {
        super(model, injector, "id", "name");

        this.extendedSearchComponent = ExtraSearchPageComponent;
    }
}
